'use strict';
const angular = require('angular');

export class CustomEntityLookupComponent {
  /*@ngInject*/
  constructor(CustomEntityService) {
    this.CustomEntityService = CustomEntityService;

    this.data = [];
  }

  $onInit = function () {
    this.config = this.resolve.config;

    this.CustomEntityService.query((data) => {
      this.data = data
        .filter(entity => entity.schemaSettings == this.config.entityType)
        .map(entity => {
          entity.data._id = entity._id;
          return entity.data
        });
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve custom entities.")
    });
  };

  ok(user) {
    this.close({$value: user});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.customEntityLookup', [])
  .component('customEntityLookup', {
    template: require('./custom-entity-lookup.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: CustomEntityLookupComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/custom-entity-lookup/custom-entity-lookup.component.js